(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melena-ingredient-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melena-ingredient-tabs')) {
    customElements.define('melena-ingredient-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-ingredient-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ingredient-panel]'));
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-ingredient-tab]');
          if (tab) this.show(Number(tab.dataset.index), true);
        });
        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-ingredient-tab]');
          if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (Number(tab.dataset.index) + direction + this.tabs.length) % this.tabs.length;
          this.show(next, true);
        });
        this.show(0, false);
      }

      show(index, focusTab) {
        if (!this.tabs.length || !this.panels.length) return;
        const next = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === next;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === next;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (focusTab) this.tabs[next].focus();
      }
    });
  }

  document.addEventListener('shopify:block:select', (event) => {
    const panel = document.querySelector(`.melena-ingredients__panel[data-block-id="${event.detail.blockId}"]`);
    const tabs = panel?.closest('melena-ingredient-tabs');
    if (panel && tabs) tabs.show(Number(panel.dataset.index), false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melena-purchase-options"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-melena-purchase] input[name="melena_plan"]');
    if (!radio) return;

    const purchase = radio.closest('[data-melena-purchase]');
    purchase.querySelectorAll('[data-plan]').forEach((plan) => plan.classList.toggle('is-selected', plan.contains(radio)));
    purchase.querySelector('[data-melena-variant]').value = radio.dataset.variantId;
    purchase.querySelector('[data-melena-quantity]').value = radio.dataset.quantity;
    purchase.querySelectorAll('[data-guarantee-image]').forEach((image) => {
      image.classList.toggle('is-visible', image.dataset.guaranteeImage === radio.closest('[data-plan]').dataset.guarantee);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melena-results-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melena-results-carousel')) {
    customElements.define('melena-results-carousel', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-review-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-review-panel]'));
        this.index = 0;
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-review-tab]');
          if (tab) this.show(Number(tab.dataset.index), true);
          if (event.target.closest('[data-review-previous]')) this.show(this.index - 1, false);
          if (event.target.closest('[data-review-next]')) this.show(this.index + 1, false);
        });
        this.show(0, false);
      }

      show(requestedIndex, focusTab) {
        const total = this.tabs.length;
        if (!total) return;
        this.index = (requestedIndex + total) % total;
        const previous = (this.index - 1 + total) % total;
        const next = (this.index + 1) % total;

        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === this.index;
          tab.classList.toggle('is-active', active);
          tab.classList.toggle('is-visible', tabIndex === previous || active || tabIndex === next);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (tabIndex === previous) tab.style.setProperty('--avatar-order', '1');
          if (active) tab.style.setProperty('--avatar-order', '2');
          if (tabIndex === next) tab.style.setProperty('--avatar-order', '3');
        });

        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === this.index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (focusTab) this.tabs[this.index].focus();
      }
    });
  }

  document.addEventListener('shopify:block:select', (event) => {
    const panel = document.querySelector(`.melena-reviews__panel[data-block-id="${event.detail.blockId}"]`);
    const carousel = panel?.closest('melena-results-carousel');
    if (panel && carousel) carousel.show(Number(panel.dataset.index), false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melena-root-causes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melena-root-carousel')) {
    customElements.define('melena-root-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = Number(this.dataset.startIndex || 0);
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-previous]')) this.show(this.index - 1);
          if (event.target.closest('[data-next]')) this.show(this.index + 1);
        });
        this.show(this.index);
      }

      show(nextIndex) {
        this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.querySelector('[data-current]').textContent = String(index + 1);
            slide.querySelector('[data-previous]').disabled = index === 0;
            slide.querySelector('[data-next]').disabled = index === this.slides.length - 1;
          }
        });
      }
    });
  }

  document.addEventListener('shopify:block:select', (event) => {
    const slide = document.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    const carousel = slide?.closest('melena-root-carousel');
    if (slide && carousel) carousel.show(Number(slide.dataset.index));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-listicle-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-melena-purchase] input[name="melena_plan"]');
    if (!radio) return;

    const purchase = radio.closest('[data-melena-purchase]');
    purchase.querySelectorAll('[data-plan]').forEach((plan) => plan.classList.toggle('is-selected', plan.contains(radio)));
    purchase.querySelector('[data-melena-variant]').value = radio.dataset.variantId;
    purchase.querySelector('[data-melena-quantity]').value = radio.dataset.quantity;
    purchase.querySelectorAll('[data-guarantee-image]').forEach((image) => {
      image.classList.toggle('is-visible', image.dataset.guaranteeImage === radio.closest('[data-plan]').dataset.guarantee);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-pdp-purchase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.ml-landing [data-melena-purchase] input[name="melena_plan"]');
    if (!radio) return;

    const purchase = radio.closest('[data-melena-purchase]');
    purchase.querySelectorAll('[data-plan]').forEach((plan) => plan.classList.toggle('is-selected', plan.contains(radio)));
    purchase.querySelector('[data-melena-variant]').value = radio.dataset.variantId;
    purchase.querySelector('[data-melena-quantity]').value = radio.dataset.quantity;
    purchase.querySelectorAll('[data-guarantee-image]').forEach((image) => {
      image.classList.toggle('is-visible', image.dataset.guaranteeImage === radio.closest('[data-plan]').dataset.guarantee);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
